
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.header-wrapper {
      position:relative;
      background-color:var(--neutral-white);
}

  .header-wrapper .header {
      justify-content:space-between;
}

  @media (min-width: 1024px) {

      .header-wrapper .header {
            display:flex;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header {
            align-items:center;
      }
}

  .header-wrapper .header-mobile-controls-organizer {
      display:flex;
}

  .header-wrapper .header-mobile-controls-organizer {
      align-items:center;
}

  .header-wrapper .header-mobile-controls-organizer {
      justify-content:space-between;
}

  .header-wrapper .header-mobile-controls-organizer {
      gap:1px;
}

  .header-wrapper .header-mobile-controls-organizer {
      padding-top:1rem;
      padding-bottom:1rem;
}

  @media (min-width: 1024px) {

      .header-wrapper .header-mobile-controls-organizer {
            padding-top:0px;
            padding-bottom:0px;
      }
}

  .header-wrapper .header-logo-wrapper {
      display:inline-block;
}

  @media (min-width: 1024px) {

      .header-wrapper .header-logo-wrapper {
            padding-right:1rem;
      }
}

  @media (min-width: 1280px) {

      .header-wrapper .header-logo-wrapper {
            padding-right:2.5rem;
      }
}

  @media (min-width: 2180px) {

      .header-wrapper .header-logo-wrapper {
            padding-right:4rem;
      }
}

  .header-wrapper .header-logo-wrapper {
      transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

  .header-wrapper .header-logo-wrapper {
      transition-duration:300ms;
}

  .header-wrapper .header-logo-wrapper:hover{
      opacity:0.8;
    }

  @media (min-width: 1024px) {

      .header-wrapper .header-mobile-controls-section {
            display:none;
      }
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      display:inline-flex;
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      min-height:29px;
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      min-width:29px;
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      cursor:pointer;
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      align-items:center;
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      justify-content:center;
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      border-width:0px;
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      background-color:var(--neutral-white);
}

  .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      transition-duration:300ms;
}

  @media (min-width: 1024px) {

      .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
            min-height:44px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
            min-width:44px;
      }
}

  .header-wrapper .header-mobile-controls-hamburger-wrapper {
      margin-left:0px;
      margin-right:0px;
}

  @media (min-width: 1024px){.header-wrapper {
  }
    .header-wrapper ghs-search-bar{
      width:calc(100% - 44px);
    }
  }

  .header-wrapper .header-links-master-section {
      display:flex;
}

  .header-wrapper .header-links-master-section {
      flex-direction:column;
}

  @media (min-width: 1024px) {

      .header-wrapper .header-links-master-section {
            display:block;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-links-master-section {
            width:100%;
      }
}

  .header-wrapper .header-dropdown-menu-section {
      display:none;
}

  .header-wrapper .header-dropdown-menu-section {
      gap:1.5rem;
}

  .header-wrapper .header-dropdown-menu-section {
      font-weight:var(--fw-semibold);
}

  @media (min-width: 1280px) {

      .header-wrapper .header-dropdown-menu-section {
            font-size:var(--fs-base);
            line-height:var(--lh-base);
      }
}

  .header-wrapper .header-dropdown-menu-section{
  }

  @media (min-width: 1024px) {

      .header-wrapper .header-dropdown-menu-section {
            display:flex;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-dropdown-menu-section {
            justify-content:space-between;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-dropdown-menu-section {
            font-size:var(--fs-sm);
            line-height:var(--lh-sm);
      }
}

  .header-wrapper .header-dropdown-menu-section{
  }

  @media (min-width: 1024px) {

      .header-wrapper .header-dropdown-menu-section {
            border-width:0px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-dropdown-menu-section {
            border-top-width:1px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-dropdown-menu-section {
            border-style:solid;
      }
}

  .header-wrapper .header-dropdown-actions-section {
      display:flex;
}

  .header-wrapper .header-dropdown-actions-section {
      gap:1.5rem;
}

  .header-wrapper .header-dropdown-actions-section {
      vertical-align:middle;
}

  .header-wrapper .hamburger-expanded .header-dropdown-menu-section {
      display:block;
}

  .header-wrapper .hamburger-expanded .header-dropdown-menu-section{
  }

  @media (min-width: 1024px) {

      .header-wrapper .hamburger-expanded .header-dropdown-menu-section {
            display:flex;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .hamburger-expanded .header-dropdown-menu-section {
            justify-content:flex-end;
      }
}

  .header-wrapper .header-button-wrapper {
      margin-top:0.75rem;
}

  @media (min-width: 1024px) {

      .header-wrapper .header-button-wrapper {
            margin-top:0px;
            margin-bottom:0px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-button-wrapper {
            display:flex;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-button-wrapper {
            flex-direction:column;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-button-wrapper {
            justify-content:center;
      }
}

  .header-wrapper .header-utilities-section {
      display:none;
}

  .header-wrapper .header-utilities-section{
  }

  @media (min-width: 1024px) {

      .header-wrapper .header-utilities-section {
            display:flex;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-utilities-section {
            align-items:center;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-utilities-section {
            justify-content:flex-end;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .header-utilities-section {
            gap:1rem;
      }
}

  @media (min-width: 1280px) {

      .header-wrapper .header-utilities-section {
            gap:1.75rem;
      }
}

  .header-wrapper .hamburger-expanded .header-utilities-section {
      margin-bottom:0.625rem;
}

  .header-wrapper .hamburger-expanded .header-utilities-section {
      display:block;
}

  .header-wrapper .hamburger-expanded .header-utilities-section{
  }

  @media (min-width: 1024px) {

      .header-wrapper .hamburger-expanded .header-utilities-section {
            margin-bottom:0px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .hamburger-expanded .header-utilities-section {
            display:flex;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .hamburger-expanded .header-utilities-section {
            justify-content:flex-end;
      }
}

  .header-wrapper .hamburger-expanded .header-utilities-link {
      margin-bottom:1.75rem;
}

  @media (min-width: 1024px) {

      .header-wrapper .hamburger-expanded .header-utilities-link {
            margin-bottom:0px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .search-expanded .header-utilities-link, .header-wrapper .search-expanded
    .header-utilities-section
    .header-utilities-link-slot-wrapper {
            display:none;
      }
}

  .header-wrapper .desktop-search-control {
      display:none;
}

  .header-wrapper .desktop-search-control {
      min-width:44px;
}

  .header-wrapper .desktop-search-control {
      cursor:pointer;
}

  .header-wrapper .desktop-search-control {
      background-color:var(--neutral-white);
}

  .header-wrapper .desktop-search-control {
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
}

  .header-wrapper .desktop-search-control {
      font-weight:var(--fw-medium);
}

  @media (min-width: 1024px) {

      .header-wrapper .desktop-search-control {
            display:flex;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .desktop-search-control {
            align-items:center;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .desktop-search-control {
            gap:0.5rem;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .desktop-search-control {
            padding-left:0.75rem;
      }
}

  .header-wrapper .desktop-search-control{
  }

  @media (min-width: 1024px) {

      .header-wrapper .desktop-search-control {
            border-width:0px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .desktop-search-control {
            border-left-width:1px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .desktop-search-control {
            border-style:solid;
      }
}

  @media (min-width: 1280px) {

      .header-wrapper .desktop-search-control {
            padding-left:1.75rem;
      }
}

  .header-wrapper .desktop-search-control ghs-icon[name='close'] {
      display:none;
}

  .header-wrapper .search-expanded .desktop-search-control {
      min-height:44px;
}

  .header-wrapper .search-expanded .desktop-search-control {
      min-width:44px;
}

  @media (min-width: 1024px) {

      .header-wrapper .search-expanded .desktop-search-control {
            position:absolute;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .search-expanded .desktop-search-control {
            top:1.25rem;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .search-expanded .desktop-search-control {
            margin-bottom:0px;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .search-expanded .desktop-search-control {
            justify-content:center;
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .search-expanded .desktop-search-control {
            border-color:var(--neutral-transparent);
      }
}

  @media (min-width: 1024px) {

      .header-wrapper .search-expanded .desktop-search-control {
            padding-left:0.5rem;
      }
}

  .header-wrapper .search-expanded .desktop-search-control .label, .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='search'] {
      display:none;
}

  .header-wrapper .header-search-wrapper {
      display:none;
}

  .header-wrapper .header hr{
  }

  .header-wrapper .header hr {
      margin-left:-1.25rem;
      margin-right:-1.25rem;
}

  .header-wrapper .header hr {
      margin-top:0px;
      margin-bottom:0px;
}

  .header-wrapper .header hr {
      display:none;
}

  .header-wrapper .header hr {
      height:1px;
}

  .header-wrapper .header hr {
      border-style:none;
}

  @media (min-width: 1024px) {

      .header-wrapper .header hr {
            display:none;
      }
}

  .header-wrapper .hamburger-expanded hr, .header-wrapper .search-expanded hr {
      display:block;
}

  @media (min-width: 1024px) {

      .header-wrapper .hamburger-expanded hr, .header-wrapper .search-expanded hr {
            display:none;
      }
}

.hamburger-check {
      position:absolute;
      top:1.25rem;
      right:1.25rem;
      height:1.5rem;
      width:1.5rem;
      opacity:0;
}

.hamburger-check:checked ~ hr {
      display:block;
}

@media (min-width: 1024px) {

      .hamburger-check:checked ~ hr {
            display:none;
      }
}

.hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
      margin-bottom:0.625rem;
}

.hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
      display:block;
}

.hamburger-check:checked ~ .header-links-master-section .header-utilities-section{
    }

@media (min-width: 1024px) {

      .hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
            margin-bottom:0px;
      }
}

@media (min-width: 1024px) {

      .hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
            display:flex;
      }
}

@media (min-width: 1024px) {

      .hamburger-check:checked ~ .header-links-master-section .header-utilities-section {
            justify-content:flex-end;
      }
}

.hamburger-check:checked ~ .header-links-master-section .header-utilities-link {
      margin-bottom:0.75rem;
}

@media (min-width: 1024px) {

      .hamburger-check:checked ~ .header-links-master-section .header-utilities-link {
            margin-bottom:0px;
      }
}

.header-mobile-top-links.search-expanded, .header-mobile-top-links.hamburger-expanded {
      display:none;
}

.header-utilities-section {
      display:flex;
}

.header-utilities-section.mobile {
      justify-content:flex-end;
}

.header-utilities-section.mobile {
      color:var(--neutral-white);
}

.header-utilities-section.mobile a {
      color:var(--neutral-white);
}

.header-wrapper .header-mobile-controls-section {
      display:flex;
}

.header-wrapper .header-mobile-controls-section {
      color:var(--primary-green);
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      display:flex;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      flex-direction:column;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      justify-content:space-between;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      border-radius:9999px;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      padding-left:0.5rem;
      padding-right:0.5rem;
}

.header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
      font-weight:var(--fw-bold);
}

@media (min-width: 1024px) {

      .header-wrapper .header-mobile-controls-search-wrapper, .header-wrapper .header-mobile-controls-hamburger-wrapper {
            display:none;
      }
}

.header-wrapper .header-mobile-controls-search-wrapper:hover, .header-wrapper .header-mobile-controls-hamburger-wrapper:hover {
      color:var(--primary-green-light-1);
}

.header-wrapper .header-mobile-controls-hamburger-wrapper{
    min-height:44px;
  }

.header-wrapper .header-mobile-controls-hamburger-wrapper ghs-icon {
      position:relative;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper ghs-icon{
      top:-4px;
    }

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
      height:2.25rem;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
      width:2.25rem;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
      align-items:center;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
      justify-content:center;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
      background-color:var(--primary-green);
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded{
      min-height:auto;
    }

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded > ghs-icon {
      position:static;
}

.header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded > ghs-icon {
      color:var(--neutral-white);
}

.header-wrapper .header-mobile-controls-search-wrapper{
    min-height:44px;
    color:var(--neutral-black);
  }

.header-wrapper .header-mobile-controls-search-wrapper ghs-icon {
      position:relative;
}

.header-wrapper .header-mobile-controls-search-wrapper ghs-icon{
      top:3px;
    }

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
      height:2.25rem;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
      width:2.25rem;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
      align-items:center;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
      justify-content:center;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
      background-color:var(--primary-green);
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded{
      min-height:auto;
    }

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded > ghs-icon {
      position:static;
}

.header-wrapper .header-mobile-controls-search-wrapper.search-expanded > ghs-icon {
      color:var(--neutral-white);
}

:host([site='GHS']) .header-mobile-top-links {
      background-color:var(--primary-blue);
}

:host([site='GHS']) .search-expanded .header-search-wrapper {
      margin-left:auto;
}

:host([site='GHS']) .search-expanded .header-search-wrapper {
      display:block;
}

:host([site='GHS']) .search-expanded .header-search-wrapper {
      padding-bottom:1.5rem;
}

@media (min-width: 1024px) {

      :host([site='GHS']) .search-expanded .header-search-wrapper {
            width:80%;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .search-expanded .header-search-wrapper {
            padding-right:3.5rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .search-expanded .header-search-wrapper {
            padding-bottom:0px;
      }
}

:host([site='GHS']) .header-wrapper{
    box-shadow:var(--brand-shadow);
  }

:host([site='GHS']) .header-wrapper .header-mobile-controls-hamburger-wrapper {
      color:var(--primary-green);
}

:host([site='GHS']) .header-wrapper .header {
      font-family:var(--ff-display);
}

:host([site='GHS']) .header-wrapper .header {
      color:var(--primary-blue);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .header-wrapper .header {
            height:86px;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .header-wrapper .header {
            min-height:5.25rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .header-wrapper .header {
            padding-top:1.25rem;
            padding-bottom:1.25rem;
      }
}

:host([site='GHS']) .header-wrapper .header .header-logo-wrapper {
      width:8rem;
}

@media (min-width: 1024px) {

      :host([site='GHS']) .header-wrapper .header .header-logo-wrapper {
            width:9rem;
      }
}

@media (min-width: 1280px) {

      :host([site='GHS']) .header-wrapper .header .header-logo-wrapper {
            width:13rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .header-wrapper .header-dropdown-menu-section {
            border-color:var(--neutral-gray-4);
      }
}

:host([site='GHS']) .header-wrapper .desktop-search-control {
      border-left-width:0px;
}

:host([site='GHS']) .header-wrapper .desktop-search-control {
      padding-left:0.5rem;
}

:host([site='GHS']) .header-wrapper .desktop-search-control {
      font-family:var(--ff-display);
}

:host([site='GHS']) .header-wrapper .desktop-search-control {
      color:var(--primary-green);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .header-wrapper .desktop-search-control {
            border-color:var(--neutral-gray-4);
      }
}

:host([site='GHS']) .header-wrapper .desktop-search-control ghs-icon[name='search'] {
      color:var(--primary-green);
}

:host([site='GHS']) .header-wrapper .desktop-search-control:hover, :host([site='GHS']) .header-wrapper .desktop-search-control:hover ghs-icon[name='search'] {
      color:var(--primary-green-light-1);
}

:host([site='GHS']) .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='close'] {
      display:block;
}

:host([site='GHS']) .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='close'] {
      color:var(--primary-green);
}

:host([site='GHS']) .header-wrapper .header-button-wrapper {
      margin-top:0px;
      margin-bottom:0px;
}

:host([site='GHS']) .header-wrapper .header-button-wrapper {
      padding-bottom:1.75rem;
}

@media (min-width: 1024px) {

      :host([site='GHS']) .header-wrapper .header-button-wrapper {
            padding-top:0px;
            padding-bottom:0px;
      }
}

:host([site='GHS']) .header-wrapper .header hr{
    }

:host([site='GHS']) .header-wrapper .header hr {
      background-color:var(--neutral-gray-4);
}

:host([site='GHS']) .header-dropdown-buttons ::slotted(*) {
      margin-left:-1rem;
      margin-right:-1rem;
}

:host([site='GHS']) .header-dropdown-buttons ::slotted(*) {
      display:flex;
}

:host([site='GHS']) .header-dropdown-buttons ::slotted(*) {
      flex-wrap:wrap;
}

:host([site='GHS']) .header-dropdown-buttons ::slotted(*) a{
        display:inline-block;
        color:white;
        background-color:black;
      }

:host([site='GHS']) .header-dropdown-buttons a.header-button{
      display:none;
    }

:host([site='BH']) .header-mobile-top-links {
      background-color:var(--bh-brand-primary-dark);
}

:host([site='BH']) ::slotted(.header-button) {
      margin-top:0.5rem;
}

:host([site='BH']) ::slotted(.header-button) {
      margin-bottom:0.5rem;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      margin-left:auto;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      display:block;
}

@media (min-width: 1024px) {

      :host([site='BH']) .search-expanded .header-search-wrapper {
            width:66.666667%;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']) .search-expanded .header-search-wrapper {
            padding-right:3.5rem;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']) .search-expanded .header-search-wrapper {
            padding-bottom:0px;
      }
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      position:fixed;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      left:0px;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      top:0px;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      z-index:50;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      display:block;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      width:100%;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      background-color:var(--neutral-white);
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      padding-left:1rem;
      padding-right:1rem;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      padding-bottom:1.5rem;
}

:host([site='BH']) .search-expanded .header-search-wrapper {
      padding-top:1rem;
}

@media (min-width: 768px) {

      :host([site='BH']) .search-expanded .header-search-wrapper {
            padding-left:4rem;
            padding-right:4rem;
      }
}

@media (min-width: 768px) {

      :host([site='BH']) .search-expanded .header-search-wrapper {
            padding-bottom:4rem;
      }
}

:host([site='BH']) .search-expanded .header-search-wrapper{
    z-index:500;
  }

:host([site='BH']) .header-wrapper{
    box-shadow:var(--brand-shadow);
  }

:host([site='BH']) .header-wrapper .header-mobile-controls-hamburger-wrapper {
      color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .header {
      font-family:var(--bh-ff-body);
}

:host([site='BH']) .header-wrapper .header {
      color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .header-logo-wrapper {
      width:8rem;
}

@media (min-width: 1024px) {

      :host([site='BH']) .header-wrapper .header-logo-wrapper {
            width:16rem;
      }
}

:host([site='BH']) .header-wrapper .header-mobile-controls-section {
      color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .header-mobile-controls-search-wrapper.search-expanded {
      background-color:var(--bh-brand-primary-lightest);
}

:host([site='BH']) .header-wrapper .header-mobile-controls-search-wrapper.search-expanded > ghs-icon {
      color:var(--bh-neutral-black);
}

:host([site='BH']) .header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded {
      background-color:var(--bh-brand-primary-lightest);
}

:host([site='BH']) .header-wrapper .header-mobile-controls-hamburger-wrapper.hamburger-expanded > ghs-icon {
      color:var(--bh-neutral-black);
}

:host([site='BH']) .header-wrapper .header-dropdown-menu-section {
      gap:0.25rem;
}

@media (min-width: 1024px) {

      :host([site='BH']) .header-wrapper .header-dropdown-menu-section {
            gap:2rem;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']) .header-wrapper .header-dropdown-menu-section {
            border-color:var(--bh-neutral-default);
      }
}

:host([site='BH']) .header-wrapper .desktop-search-control {
      font-family:var(--bh-ff-body);
}

:host([site='BH']) .header-wrapper .desktop-search-control {
      color:var(--bh-brand-primary-dark);
}

@media (min-width: 1024px) {

      :host([site='BH']) .header-wrapper .desktop-search-control {
            border-color:var(--bh-neutral-default);
      }
}

:host([site='BH']) .header-wrapper .desktop-search-control ghs-icon[name='search'] {
      color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .desktop-search-control:hover, :host([site='BH']) .header-wrapper .desktop-search-control:hover ghs-icon[name='search'] {
      color:var(--bh-brand-primary-light);
}

@media (min-width: 1024px) {

      :host([site='BH']) .header-wrapper .search-expanded .desktop-search-control {
            min-height:22px;
      }
}

:host([site='BH']) .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='close'] {
      display:block;
}

:host([site='BH']) .header-wrapper .search-expanded .desktop-search-control ghs-icon[name='close'] {
      color:var(--bh-brand-primary-default);
}

:host([site='BH']) .header-wrapper .header-button-wrapper, :host([site='BH']) .header-wrapper .header-button-wrapper > *, :host([site='BH']) .header-wrapper .header-button-wrapper > * > * {
      min-height:44px;
}

:host([site='BH']) .header-wrapper .header hr{
    }

:host([site='BH']) .header-wrapper .header hr {
      background-color:var(--bh-neutral-default);
}

@media (min-width: 1024px) {

      :host([site='BH']):host([logo-variant='bhLogoBellinRun']) .header-wrapper .header-logo-wrapper {
            width:8rem;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']):host([logo-variant='bhLogoBellinRun']) .header-wrapper .header-logo-wrapper {
            padding-top:0.5rem;
            padding-bottom:0.5rem;
      }
}

@media (min-width: 1280px) {

      :host([site='BH']):host([logo-variant='bhLogoBellinRun']) .header-wrapper .header-logo-wrapper {
            width:11rem;
      }
}
`;